
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { collection, getDocs, query, where, orderBy, Timestamp, limit, updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase.js";
import Lodinging from "../components_root/loading.jsx";
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';

import { Toast } from '../components_root/ToastContext.jsx';
import { SlLike } from "react-icons/sl";
import { MdAdd, MdDataset, MdDateRange, MdFilterList, MdLabel, MdRefresh, MdResetTv, MdSearch, MdSend, MdTextFormat } from 'react-icons/md';
import { Save_community } from './save_community.js';
import './community.css';
import CategorySelect from './CategorySelect.jsx';
export default function Community() {
  const navigate = useNavigate();
  const location = useLocation();
  const [id, setId] = useState('');
  const [islogin, setIslogin] = useState(false);
  const { Toastshow } = Toast();
  const [isLoading, setIsLoading] = useState(true);
  const [titledata, setTitledata] = useState();
  const [messagedata, setMessagedata] = useState();
  const [categoriesdata, setCategoriesata] = useState();
  const [keywordsdata, setkeywordsdata] = useState();
  const [guid, setguid] = useState('');
  const [isadminlogin, setisadminlogin] = useState(true);
  const [isaddcomm, setisisaddcomm] = useState(false);
  const [categorieslistdata, setCategorieslistdata] = useState([]);

  const [error, setError] = useState(null);
  const [searchvalue, setSearchvalue] = useState('');
  const [sessiontoken, setsessiontoken] = useState([]);
  const [tradeMaster, setTradeMaster] = useState([]);
  const [communitydata, setCommunitydata] = useState([]);
  const [categoryselected, setcategoryselected] = useState(null);

  useEffect(() => {
  
    const existingsessiontoken = Cookies.get("sessiontoken");
    if (existingsessiontoken !== null && existingsessiontoken !== undefined) {
      setsessiontoken(existingsessiontoken);
      setIslogin(true);
        setguid(Cookies.get("guid"));
    }
  }, []);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const communityId = params.get('id');

    if (communityId != null) {
      get_community_by_id(communityId);
    }

  }, [location]);
  const get_trade_master = async () => {
    try {
      const masterQuery = query(
        collection(db, "setting_master"),
        where("status", "==", true)
      );
      const masterSnap = await getDocs(masterQuery);
      const dataList = masterSnap.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      }));
 
      setTradeMaster(dataList);
    } catch (error) {
      console.error("❌ Error in get_trade_master:", error);
    }
  };
  useEffect(() => {
 
    get_trade_master();

  }, [guid]);

  useEffect(() => {
    if (islogin ==true && tradeMaster.length > 0 && tradeMaster[0].guid === guid) {
      setisadminlogin(true);
    } else {
     setisadminlogin(false); // Optional: reset if not matched
    }
  }, [guid, tradeMaster]);
  const get_community_by_id = async (communityId) => {
    try {
      setcategoryselected("");
      const masterQuery = query(
        collection(db, "community"),
        where("status", "==", true),
        where("uid", "==", communityId),
      );
      setIsLoading(true);
      const masterSnap = await getDocs(masterQuery);
      const dataList = masterSnap.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      }));

      setCommunitydata(dataList);
      setIsLoading(false);

    } catch (error) {
      console.error("❌ Error in get_trade_master:", error);
    }

  };
  const post_community = async () => {
    if (!titledata) {
      Toastshow("Enter title");
      return;
    }
    if (!messagedata) {
      Toastshow("Enter message");
      return;
    }
    if (!categoriesdata) {
      Toastshow("Enter categories");
      return;
    }
    if (!keywordsdata) {
      Toastshow("Enter keywords");
      return;
    }
    try {
      const result = await Save_community({
        title: titledata,
        message: messagedata,
        categories: categoriesdata.toLowerCase(),
        keywords: keywordsdata.toLowerCase()
      });

      if (result.success) {
        Toastshow("Post submitted successfully!");
        setTitledata('');
        setMessagedata('');
        get_community();  // Refresh or fetch community posts
      } else {
        Toastshow("Error submitting post: " + (result.error || ""));
      }
    } catch (error) {
      console.error(error);
      Toastshow("Error submitting post");
    }
  };
  const get_search_community = async () => {
    try {
      const masterQuery = query(
        collection(db, "community"),
        where("status", "==", true),
        orderBy("date_time", 'asc')
      );

      const masterSnap = await getDocs(masterQuery);
      const dataList = masterSnap.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      }));

      const filtered = dataList.filter(item =>
        item.title?.toLowerCase().includes(searchvalue.toLowerCase())
      );

      setCommunitydata(filtered);
    } catch (error) {
      console.error("❌ Error in get_search_community:", error);
    }
  };
  useEffect(() => {
    if ((searchvalue ?? '').length > 0) {
      get_search_community();
    } else {
      get_community();
    }
  }, [searchvalue]);
  const get_community = async () => {
    try {
      setcategoryselected("");
      const masterQuery = query(
        collection(db, "community"),
        where("status", "==", true),
        orderBy("date_time", "asc"),
        limit(20)
      );
      setIsLoading(true);
      const masterSnap = await getDocs(masterQuery);
      const dataList = masterSnap.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      }));

      setCommunitydata(dataList);
      setIsLoading(false);

    } catch (error) {
      console.error("❌ Error in get_trade_master:", error);
      setIsLoading(false);
    }

  };

  useEffect(() => {
    get_community();
    get_Categories();
  }, [guid]);
  const get_community_categories = async (categories) => {
    try {
      const masterQuery = query(
        collection(db, "community"),
        where("status", "==", true),
        where("categories", "==", categories),
        orderBy("date_time", "asc"),
        limit(50)
      );
      setIsLoading(true);
      const masterSnap = await getDocs(masterQuery);
      const dataList = masterSnap.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      }));

      setCommunitydata(dataList);
      setIsLoading(false);

    } catch (error) {
      setIsLoading(false);
      console.error("❌ Error in get_trade_master:", error);
    }
  };
  //
  const get_Categories = async () => {
    try {

      const masterQuery = query(
        collection(db, "community"),
        where("status", "==", true),
        orderBy("categories", "asc"),
      );

      const masterSnap = await getDocs(masterQuery);
      const dataList = masterSnap.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      }));

      // Filter only unconfirmed posts
      const unconfirmedPosts = dataList.filter(
        item => item.status_confirmed === false || item.status_confirmed === undefined
      );

      // Count posts per category
      const categoryMap = new Map();
      unconfirmedPosts.forEach(item => {
        const category = item.categories || "Uncategorized";
        if (!categoryMap.has(category)) {
          categoryMap.set(category, { category, count_post: 1 });
        } else {
          categoryMap.get(category).count_post += 1;
        }
      });

      const countedCategories = Array.from(categoryMap.values());

      setCategorieslistdata(countedCategories); // Now contains { category, count_post }

    } catch (error) {
      console.error("❌ Error in Categories:", error);
    }
  };
  const handleLike = async (likes, uid) => {

    const likedKey = `liked_${uid}`;
    const alreadyLiked = localStorage.getItem(likedKey);
    if (alreadyLiked) {
      Toastshow("already Liked");
      return;
    }
    try {
      const postRef = doc(db, "community", uid);
      await updateDoc(postRef, {
        like: Number(likes) + 1,
      });
      localStorage.setItem(likedKey, "true"); // prevent re-liking
    } catch (error) {
      console.error("Error updating likes:", error);
    }
  };


  return (
    <div>
      <Header />
   <Helmet>
  <title>AI Community | Education, Support & Video Tips - Viabig</title>

  <meta
    name="description"
    content="Join the Viabig AI Community to learn Artificial Intelligence through education resources, user guide video tips, and peer support. Explore AI tools, tutorials, and connect with learners worldwide."
  />

  <meta
    name="keywords"
    content="Viabig AI community, AI education, Artificial Intelligence tutorials, AI support, AI video tips, machine learning help, AI discussion forum, deep learning resources, AI tools guide"
  />

  <meta name="author" content="Viabig.com" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="Viabig AI Community | Learn, Connect & Grow" />
  <meta
    property="og:description"
    content="Be part of the Viabig AI Community. Learn Artificial Intelligence, access tutorials and video tips, and connect with AI learners and experts. Share insights, ask questions, and grow together."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.viabig.com/community" />
  <meta property="og:image" content="https://www.viabig.com/assets/viabig-ai.png" />
</Helmet>


      <div className="container_roots">
        <div className="container_size">
          <br />
          <div className='title-text'>Community, Education, and Get Help & Connect</div>
          <br />
          <div className='comm_search_div'>
            <MdSearch className='icon' />
            <input
              onChange={(e) => setSearchvalue(e.target.value)}
              value={searchvalue}
              className='search_input'
              placeholder='Search'
            />
            {isadminlogin === true && (

              <MdAdd
                className='icon'
                onClick={() => {
                  setisisaddcomm(prev => !prev);
                }}
              />
            )}

          </div>
          <br />
          <div className='post-container'>
            <div className='post_updates'>
              <div className='contact-title-div '>
                <div className='text-h1 bold '>Categories visyes</div>
                <br />
                <div className="ui-grid comm_items">
                  {[...categorieslistdata].reverse().map((row, i) => (
                    <div key={i} className="ui-items items-back"  >
                      <table>
                        <tbody>
                          <tr
                            className={`cursor ${categoryselected === row.category ? "primary" : ""}`}
                            onClick={(e) => {
                              get_community_categories(row.category);
                              setcategoryselected(row.category);
                            }}
                          >
                            <td   className="text-h2 fcap p-2">
                              {row.category}
                            </td>
                            <td  width={30} className="text-5 bold">
                              {row.count_post}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  ))}
                </div>

              </div>
            </div>

            <div className='post_div'>

              {isadminlogin === true && isaddcomm === true && (
                <div className='post-body items-back '>
                  <input
                    value={titledata}
                    onChange={(e) => setTitledata(e.target.value)}
                    className="contact-title bold"
                    style={{ border: "none" }}
                    maxLength={150}
                    placeholder='Title'
                  />
                  <textarea className="message_text"
                    onChange={(e) => setMessagedata(e.target.value)}
                    value={messagedata}
                    style={{ border: "none" }}
                    rows={5}
                    placeholder='Message here'
                  />
                  <CategorySelect
                    value={categoriesdata}
                    onChange={(e) => setCategoriesata(e.target.value)}
                  />
                  <input
                    value={keywordsdata}
                    onChange={(e) => setkeywordsdata(e.target.value)}
                    className="contact-header"
                    maxLength={500}
                    style={{ border: "none" }}
                    placeholder='keywords'
                  />
                  <table className='border-top'>
                    <tbody>
                      <tr>
                        <td>
                          <div className='button-ui2'>
                            <MdTextFormat className='icon' /> 0
                          </div>
                        </td>
                        <td width={80}>
                          <div onClick={post_community} className='button-ui2'>
                            <MdSend className='icon' /> Post
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              <div  >
                <table >
                  <tr>
                    <td ><div className='button-ui2'><MdLabel className='icon' />Result {communitydata.length}</div> </td>
                    <td width={80} ><div onClick={() => get_community()} className='button-ui2'><MdRefresh className='icon' />Reset</div> </td>
                  </tr>
                </table>
              </div>
              {isLoading ? (
                <Lodinging />
              ) : communitydata.length === 0 ? (
                <p>Community list not update</p>
              ) : (
                <div className="ui-grid-fill comm_items ">
                  {[...communitydata]
                    .reverse()
                    .filter(row => row.status_confirmed === false || row.status_confirmed === undefined)
                    .map((row, i) => (
                      <div
                        key={i}
                        className="ui-items items-back"
                        style={{ padding: "10px 10px" }}
                      >
                        <table>
                          <tbody>
                            <tr>
                              <td className="text-h1 bold">{row.title}</td>
                            </tr>
                            <tr>
                              <td>
                                <div
                                  className="message_text"
                                  dangerouslySetInnerHTML={{ __html: row.message }}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <a className="button-ui2 bold fcap p-2 " title="Categories"  >
                                  {row.categories}
                                </a>
                                <a className="text-h3 fcap p-2 " >
                                  Keywords: {row.keywords.replace(/,\s*/g, ', ')}
                                </a>
                              </td>
                            </tr>
                            <tr >
                              <td>
                                <div className='items-back border-top'>
                                <table>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <div className="text-h3 color_light">
                                          Publish:
                                          {row.date_time.toDate().toLocaleDateString()}{" "}
                                          {row.date_time.toDate().toLocaleTimeString()}
                                        </div>
                                      </td>
                                      <td width={70}>
                                        <div
                                          className="button-ui"
                                          onClick={() => handleLike(row.like || 0, row.uid)} // ✅ wrapped in arrow function
                                          style={{ padding: "4px 12px", margin: "0px 2px" }}
                                        >
                                          {row.like || 0}
                                          <SlLike className="icon" />
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ))}
                </div>
              )}

            </div>
            <div className='post_updates'>
              <div className='contact-title-div '>
                <div className='contact-header bold'>Helpful Video Tips for Users</div>

                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footers />
      <Navbar />
    </div>
  );
}
